module.exports = __webpack_public_path__ + "static/img/arrow-left.d3907d17.svg";